import { render, staticRenderFns } from "./sendtestred.vue?vue&type=template&id=1b0b693c&scoped=true"
import script from "./sendtestred.vue?vue&type=script&lang=js"
export * from "./sendtestred.vue?vue&type=script&lang=js"
import style0 from "./sendtestred.vue?vue&type=style&index=0&id=1b0b693c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0b693c",
  null
  
)

export default component.exports